import { prop } from 'ramda';

export const watchListsSelector = prop('watchLists');


// WEBPACK FOOTER //
// ./src/selectors/watchListsSelectors.js